const EXTRA_VACATION = 2;
const FINANCIAL_BONUS = 5;
const CAREER_GROWTH = 7;
const CORPORATE_EVENT = 8;
const FLEXIBLE_WORKING_HOURS = 9;
const DESKTOP_BENEFITS = 10;
const EDUCATIONAL_COURSES = 13;
const CAFETERIA = 16;
const COMPANY_GOODS_DISCOUNTS = 17;
const CONTRIBUTION_TO_SPORTS = 20;
const MEAL_ALLOWANCE = 21;
const INSURANCE_CONTRIBUTION = 23;
const FRIENDLY_ENVIRONMENT = 29;
const WORKPLACE_FOOD = 33;
const PARKING = 40;

const POPULAR_BENEFITS_ID = [
	FINANCIAL_BONUS,
	EXTRA_VACATION,
	MEAL_ALLOWANCE,
	INSURANCE_CONTRIBUTION,
	FRIENDLY_ENVIRONMENT,
	CORPORATE_EVENT,
	EDUCATIONAL_COURSES,
	FLEXIBLE_WORKING_HOURS,
	CONTRIBUTION_TO_SPORTS,
	CAREER_GROWTH,
	PARKING,
	CAFETERIA,
	COMPANY_GOODS_DISCOUNTS,
	WORKPLACE_FOOD,
	DESKTOP_BENEFITS
];

/**
 * list of the most used benefits - https://coweo.myjetbrains.com/youtrack/issue/JP-5098/JenFirmy-hodnoceni-Benefity#focus=Comments-4-11666.0-0
 * 23 701    Finanční bonusy / prémie
 * 22 908    Dovolená navíc
 * 22 478    Příspěvek na stravování
 * 14 617    Příspěvek na spoření / pojištění
 * 14 422    Přátelské prostředí
 * 13 783    Firemní akce
 * 12 334    Vzdělávací kurzy
 * 10 125    Pružná pracovní doba
 * 9 472    Příspěvek na sport
 * 9 421    Kariérní růst
 * 9 153    Parkoviště
 * 8 884    Kafetérie
 * 8 278    Slevy na firemní zboží
 * 8 103    Občerstvení na pracovišti
 * 7 636    Pracovní zařízení (mobil, PC, notebook...)
 */

interface IBenefit {
	id: number;
	name: string;
}

const findById = (benefits: Array<IBenefit>, id: number): IBenefit | undefined =>
	benefits.find((benefit) => benefit.id === id);

export const sort = (benefits: Array<IBenefit>) => {
	const result: Array<IBenefit> = [];
	POPULAR_BENEFITS_ID.map((benefitId: number) => {
		const benefit: IBenefit | undefined = findById(benefits, benefitId);
		if (benefit !== undefined) {
			result.push(benefit);
		}
	});

	benefits.map((benefit: IBenefit) => {
		if (!POPULAR_BENEFITS_ID.includes(benefit.id)) {
			result.push(benefit);
		}
	});

	return result;
};
